// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d42a0b78","719":"296b7c4e","829":"766b1e89","919":"44f930dc"}[chunkId] + ".chunk.js";
};